import request from "@/router/axios";

// 获取检查类型列表
export const getList = (data) => {
  return request({
    url: "/api/produce/safey-type/select/page",
    method: "post",
    data,
  });
};

// 获取检查类型详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/safey-type/select/id",
    method: "get",
    params: { id },
  });
};

// 新增检查类型
export const add = (data) => {
  return request({
    url: "/api/produce/safey-type/insert",
    method: "post",
    data,
  });
};

// 更新检查类型
export const update = (data) => {
  return request({
    url: "/api/produce/safey-type/update",
    method: "post",
    data,
  });
};

// 删除检查类型
export const remove = (id) => {
  return request({
    url: "/api/produce/safey-type/delete/id",
    method: "get",
    params: { id },
  });
};
